import type { SimpleGit } from 'simple-git';

export async function tryConfigGet(g: SimpleGit, key: string): Promise<string | null> {
  try {
    const out = await g.raw(['config', '--get', key]);
    const v = String(out).trim();
    return v || null;
  } catch {
    return null;
  }
}
